<template>
  <section class="redirect">
    <div class="redirect__text">
      <h1
        class="heading"
        v-html="
          $t('PLEASE_WAIT_N_SECONDS_TILL_LINK', {
            seconds: timer,
          })
        "
      ></h1>
      <router-link to="/my/buy"
      >{{ $t('WANT TO SKIP THIS?') }}
        {{ $t('BUY_PLUS') }}
      </router-link
      >
      <p class="text g-text" v-html="$t('STEVE_JOBS_QUOTE')"></p>
    </div>
    <img class="redirect__img" src="@/assets/redirect.svg"/>
  </section>
</template>

<script>
export default {
  data() {
    return {
      timer: '∞',
    };
  },
  computed: {
    title() {
      return this.$t('REDIRECTING');
    },
  },
  methods: {
    redirect(ticket, isForced) {
      this.$api.getRedirectLink(ticket)
        .then((response) => {
          if (isForced) {
            window.location = response.link;
            return;
          }
          const link = document.createElement('a');
          link.setAttribute('href', response.link);
          link.text = this.$t('LINK_IS_READY_CONTINUE');
          document.querySelector('.redirect h1.heading').innerHTML = `${link.outerHTML}<hr/>`;
        });
    },
  },
  created() {
    this.$api.getRedirectParams(this.$route.params.ticket)
      .then((response) => {
        if (!response.wait) {
          this.redirect(response.redirection_ticket, true);
          return;
        }

        this.timer = response.wait;
        const interval = setInterval(() => {
          this.timer -= 1;
          if (!this.timer) {
            clearInterval(interval);
            this.redirect(response.redirection_ticket, false);
          }
        }, 1000);
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.redirect {
  display: flex;

  @include notebook {
    flex-direction: column;
    align-items: center;
  }

  &__text {
    max-width: 450px;
    margin-right: 30px;

    @include notebook {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }

  &__img {
    max-width: 100%;
  }
}

.heading {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 7px;
}

.text {
  margin-top: 30px;
}
</style>
